var _path, _path2, _path3, _g, _path4, _path5, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDesktopAnimation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5000,
    height: 304,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5000 304H0L.008 25C1536.51 82.245 3590.51 181.173 5000 304z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4767.5 277C3712.33 175.925 1005.91 25.784 7 2",
    stroke: "#fff",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4568 279C3590.13 206.973 992.39 72.746 5 50.5",
    stroke: "#FE9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#desktop-animation_svg__filter0_f_2062_14613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3020 297.831l12.77-108.8h53.61l13.62 108.8-40-30.978-40 30.978z",
    fill: "#010E23"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3026.4 201.722h67.2v54.4h-67.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3024.8 161l71.74 3.2v128.83l-35.88-35.559-35.86 35.559V161zm44.24 70.617l18.5-3.897-4.38-13.078-17.73 7.242 2.18-18.381h-13.89l1.39 18.703-17.12-7.353-4.18 12.867 18.51 4.292-12.35 13.63 11.16 8.042 9.74-16.212 9.74 16.212 10.95-8.042-12.52-14.025z",
    fill: "#222F64"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "desktop-animation_svg__filter0_f_2062_14613",
    x: 3016,
    y: 185.031,
    width: 88,
    height: 116.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2062_14613"
  })))));
}

export default "data:image/svg+xml;base64,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";
export { SvgDesktopAnimation as ReactComponent };